<template>
    <div>
        <a-row>
            <a-col :span="1">
                <a-button type="primary" @click="visible=true">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;" @click="editPower(row)">编辑权限</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="del(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible" title="编辑角色信息" ok-text="确定" cancel-text="取消" @ok="add"
                 @cancel="resetForm">
            <a-form-model ref="roleForm" :rules="rules" :model="form" :label-col="{ span: 4 }"
                          :wrapper-col="{ span: 20 }">
                <a-form-model-item label="角色名称" prop="name">
                    <a-input v-model="form.name"/>
                </a-form-model-item>
                <a-form-model-item label="角色代码" prop="code">
                    <a-input v-model="form.code"/>
                </a-form-model-item>
                <a-form-model-item label="角色描述">
                    <a-input v-model="form.descpt"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <a-modal v-model="powerVisible"
                 title="编辑角色具有权限"
                 width="60%"
                 :bodyStyle="{height: '60vh'}"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="addPower"
                 @cancel="resetForm">
            <a-spin :spinning="spinning">
                <a-tree
                        v-model="selectPowerList"
                        :checkable="true"
                        style="min-height:55vh;max-height:55vh;overflow:scroll;"
                        :replaceFields="{title:'name', key:'id'}"
                        :auto-expand-parent="true"
                        :tree-data="powerList"
                />
            </a-spin>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {
        getRoleQueryList,
        roleEditDetail,
        roleDelDetail,
        roleQueryPowerByRoleId,
        roleEditPowerByRoleId,
        getPowerQueryList
    } from "./js/ApiRole";
    import notification from 'ant-design-vue/es/notification'

    const columns = [
        {
            title: '角色名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '角色代码',
            dataIndex: 'code',
            key: 'code',
            ellipsis: true,
        },
        {
            title: '角色描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                data: {},
                visible: false,
                delVisible: false,
                orgList: [],
                dataPowerLevelList: [],
                rules: {
                    name: [{required: true, message: '请输入角色名称', trigger: 'blur'}],
                    code: [{required: true, message: '请输入角色代码', trigger: 'blur'}]
                },
                form: {
                    name: '',
                    code: '',
                    descpt: ''
                },
                spinning: false,
                powerVisible: false,
                selectPowerList: [],
                powerList: [],
                line: {},
            }
        },
        methods: {
            //新增
            add() {
                this.$refs.roleForm.validate(valid => {
                    if (valid) {
                        roleEditDetail(this.form).then(() => {
                            this.getData()
                        })
                    }
                });
            },
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            //删除
            del(row) {
                this.delVisible = true;
                this.line = row;
            },
            delOk(){
                roleDelDetail({id: this.line.id}).then(() => {
                    this.getData();
                    this.delVisible = false;
                }).catch(()=>{
                    this.delVisible = false;
                })
            },
            cancel(){
                this.delVisible = false;
            },
            editPower(row) {
                this.spinning = true;
                this.line = row;
                roleQueryPowerByRoleId({id: row.id}).then(res => {
                    this.spinning = false;
                    if (res.data.data.suPowers) {
                        let powerList = [];
                        res.data.data.suPowers.forEach(item => {
                            powerList.push(item.id)
                        });
                        this.selectPowerList = powerList;
                    }
                    this.powerVisible = true
                }).catch(() => {
                    this.spinning = false;
                    this.powerVisible = false;
                    notification.error({
                        message: '角色权限加载失败，请检查网络环境',
                    });
                });
            },
            addPower() {
                let selectPowerList = [];
                this.selectPowerList.forEach(item => {
                    let power = this.powerList.find(item2 => {
                        return item2.id === item
                    });
                    if (power) {
                        selectPowerList.push(power);
                    }
                });
                this.line.powers = selectPowerList;
                roleEditPowerByRoleId(this.line).then(() => {
                    this.getData();
                })
            },
            getData(parameter) {
                this.resetForm();
                if (parameter === null || parameter === undefined) {
                    parameter = {}
                }
                getRoleQueryList(parameter).then(res => {
                    this.data = res.data;
                    this.visible = false
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                if (this.$refs.userForm !== undefined) {
                    this.$refs.userForm.clearValidate();
                }
                this.form = {
                    name: '',
                    code: '',
                    descpt: ''
                };
                this.spinning = false;
                this.powerVisible = false;
                this.selectPowerList = [];
                this.line = {};
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                getRoleQueryList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
        },
        created() {
            this.getData();
            getPowerQueryList({}).then(res => {
                this.powerList = res.data.data
            })
        }
    }
</script>

<style scoped>
    .Tips{
        font-size: 20px;
        color: #1890ff;
    }
</style>
